<template>
  <div
    id="logoutPage"
    class="container main-content"
  >
    <div class="row">
      <div class="col-xs-12">
        <img
          alt=""
          src="/img/header.png"
          class="img-responsive drop-shadow"
        >
      </div>
    </div>
    <div
      class="text-center logout-background border-radius-large box-shadow"
      style="max-width: 1140px; display: flex; flex-direction: column; margin: 0 auto;"
    >
      <div>
        <LanguageSelector />
      </div>
      <div>
        <h4>{{ $t('logout.header') }}</h4>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import LanguageSelector from '@/components/LanguageSelector'
export default {
  name: 'LogoutPage',
  components: { LanguageSelector },

}
</script>

 <style lang="less">
  @import '../assets/css/bootstrap-variables.less';
  @import '../assets/css/styles.less';
    .logout-background {
      background: @blue-very-soft;
      border: 1px solid @brand-blue;
    }
</style>
